/**
 * Pagination Configuration
 *
 * This file contains all pagination settings used throughout the application.
 * Different page sizes are used for user-facing pages vs admin pages.
 */

export const PAGINATION = {
  /**
   * User-facing pages (smaller page sizes for better UX)
   */
  USER_PAGES: {
    /** Trading recommendations list page */
    TRADING_RECOMMENDATIONS: 10,
    /** Swing trades list page */
    SWING_TRADES: 10,
    /** Long term trades list page */
    LONG_TERM_TRADES: 10,
  },

  /**
   * "Fetch all" limit for counting and stats
   * Used when we need to fetch all records for totals
   * Note: Consider implementing proper pagination instead of fetching 1000+ records
   */
  FETCH_ALL_LIMIT: 1000,

  /**
   * Chart configuration for graph data points
   * Uses backend downsampling via /symbols/{sid}/graph endpoint
   */
  CHART: {
    /** Number of data points for detail views (full chart) */
    DETAIL_POINTS: 1000,
    /** Number of data points for card/list mini charts */
    CARD_POINTS: 200,
  },
} as const;
